import React, { useState, useEffect } from 'react';
import moment from 'moment'
import SelectForm from './../components/Complements/SelectForm';
import Title from './../components/Complements/Title';
import DateFnsUtils from '@date-io/date-fns';
import "moment/locale/es";
import esLocale from "date-fns/locale/es";
import { connect } from 'react-redux';
import { getCodes } from "./../actions/codes";
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
  } from '@material-ui/pickers';
import { Grid, CircularProgress, Icon, Fab, FormControl, InputLabel, Select, MenuItem, Button } from '@material-ui/core';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import './../components/Codes/style/tableresponsive.css';
import Pagination from '@material-ui/lab/Pagination';
import Alert from '@material-ui/lab/Alert';
import Dashboard from '../components/Menu/Dashboard';
import { history } from '../helpers/history';
import LoadingScreen from '../components/Complements/LoadingScreen';
import StandardDialog from '../components/Complements/StandardDialog';
import { urlCertificates } from '../services/urls';
import { sendEmailWithVoucher } from "../actions/sendEmailWithVoucher";
import { findTransferCore } from "../actions/transferscore";
//import md5 from 'md5';
import { sendMobile } from '../functions/mobile';
import { feathersFindDataAllDefault } from "../services"
import { isMobile } from 'react-device-detect';
import { filterArrayEqual } from '../functions/arrays';

const ConsultCertificatesContainer = props => {
    const { classes, balances, handleOpenSnack, certificates, getCertificatesCore,auth/* , parameters */ } = props
    const [ codespaginate, setCodesPaginate ] = useState([])
    const [ page, setPage ] = useState(1)
    const [ count, setCount ] = useState(1)
    const [ loading, setLoading ] = useState(false)
    const [ dialog, setDialog ] = useState({
        open: false,
        title: '',
        children: <div></div>
    })
    const [ dateStart, setDateStart ] = useState(new Date(moment().startOf('month')))
    const [ dateEnd, setDateEnd ] = useState(new Date(moment().endOf('month')))
    const [ dateValue, setDateValue ] = useState(JSON.stringify({month: moment().month(), year: moment().year()}))
    const [accountSelected, setAccountSelected ] = useState(balances[0])


    const mount = () => {
        const unmount = () => {
            // setLoading(true)
            moment.locale('es-es')
            if (certificates.length <= 0) {
                getCertificatesCore(/*filterArrayEqual(parameters, 'code', 'SEQUENTIAL_COMPANY')[0].value*/).then(
                    ()=>  handleGetDataMovementsBySecuencialAccount(0, dateStart, dateEnd, 1, accountSelected.PRODUCTBANKID)).catch(
                    (err)=> {
                        //console.log(JSON.stringify(err))
                        // handleOpenSnack("no se ha podido cargar la informacion, por favor intente a.", "error")
                        // setLoading(false)
                    } )
            }else{
                handleGetDataMovementsBySecuencialAccount(0, dateStart, dateEnd, 1, accountSelected.PRODUCTBANKID)
            }
        }
        return unmount()
    }

    useEffect(mount, [auth, handleOpenSnack])

    const handleGetDataMovementsBySecuencialAccount = async(rows, valuedateStart, valuedateEnd, numberpage, secuencial) => {

        setLoading(true)

        try {
            const responseCertificates = await feathersFindDataAllDefault("user-certificates", {
                $limit: 10,
                $skip : rows,
                accountSequential : secuencial,
                createdAt: {
                    $lte: valuedateEnd,
                    $gte: valuedateStart
                }
            })()

            // console.log(responseCertificates)

            const { data, total } = responseCertificates

            convertJsonToData(data, total, numberpage)

            setLoading(false)

        } catch (error) {
            //console.log(error)
            handleOpenSnack("Ha ocurrido un error al consultar los certificados.", "error")
            setLoading(false)
        }

    }

    const convertJsonToData = (data, total, numberpage) => {
        
        const result = data.map(function (row, index, array) {
			
            let dateone = new Date();
            let datetwo = new Date(row.expiryDate);
            return {
                accountSequential : row.accountSequential,
                body : row.body,
                createdAt : row.createdAt,
                expiryDate : row.expiryDate,
                certificateSequential : row.certificateSequential,
                id : row.id,
                state : (dateone.getTime() < datetwo.getTime()) ? row.state : "Caducado",
                type : row.type,
                updatedAt : row.updatedAt,
                user : row.user,
                nameFile : row.nameFile
            }
            
        })

        setCodesPaginate(result)

        getDataViewTable(total, numberpage);
            
    }


    const handleDateStart = (date) => {
        setDateStart(date)
    }

    const handleDateEnd = (date) => {
        setDateEnd(date)
    }

    const onChangePaginationCodes = (e, numberpage) => {
    
        handleGetDataMovementsBySecuencialAccount((numberpage - 1)*10, dateStart, dateEnd, numberpage, accountSelected.PRODUCTBANKID);
        //setTransactionPaginate(datacodespaginate)
        //setPage(numberpage)
    }

    const handleSubmit = (val) => {
        // console.log(val)
    }
    

    const getDataViewTable = (total, numberpage) => {
        // console.log("*** CODES ***", codes)
        let contador = parseInt((total / 10).toString());
        let residuo = total % 10;

        if(residuo > 0){
            contador++;
        }

        setCount(contador)
        setPage(numberpage)
    }

    const handleAccountFind = (value) => {

        setAccountSelected(value)
        handleGetDataMovementsBySecuencialAccount(0, dateStart, dateEnd, 1, value.Secuencial)
        
    }

    const handleSelectCode = (val) => {
        // console.log(val)
        setDateValue(val)
        setLoading(true)
        if (val === 'Todos los movimientos') {
            setLoading(false)
            
        } else {
            let obj = JSON.parse(val)
            // console.log('busca mes', obj.month)

                let selectMonth = new Date(obj.year, obj.month, 1)
                
                setDateStart(moment(selectMonth).startOf('month'))
                setDateEnd(moment(selectMonth).endOf('month'))
                //filterCodesByDate(dateStart, dateEnd, allcodes)
                setDateValue(val)
                setLoading(false)
                handleGetDataMovementsBySecuencialAccount(0, new Date(moment(selectMonth).startOf('month')), new Date(moment(selectMonth).endOf('month')), 1, accountSelected.PRODUCTBANKID)
        }
        
    }
    const handleFindRange = () => {
        if (certificates.length <= 0) {
            // console.log('BUSCANDO CERTIFICADOS')
            getCertificatesCore(/*filterArrayEqual(parameters, 'code', 'SEQUENTIAL_COMPANY')[0].value*/).then(
                (res)=> handleGetDataMovementsBySecuencialAccount(0, dateStart, dateEnd, 1, accountSelected.PRODUCTBANKID) ).catch(
                (err)=> {
                    //console.log(err)
                    // handleOpenSnack("no se ha podido cargar la informacion, por favor intente a.", "error")
                    setLoading(false)
                } )
        } else {
            handleGetDataMovementsBySecuencialAccount(0, dateStart, dateEnd, 1, accountSelected.PRODUCTBANKID)
        }
        
    }

    const handleViewVoucher = (row) => {
        try {
            //console.log(row)
            const namefile = row.nameFile
            if(isMobile === true){
                
                let send = {
                    type: 'action',
                    action: 'export_voucher',
                    data: urlCertificates+namefile+".pdf",
                    nameFile: namefile,
                    extension: 'pdf',
                    messageSend: 'Certificado'
                }
                sendMobile(JSON.stringify(send))
            
            }else{
                window.open(urlCertificates+namefile+".pdf", '_blank');
            }
        } catch (error) {
            //console.log(error)
            handleOpenSnack("Ha ocurrido un error. Por favor vuelva a intentar.", "error")
        }

        
    }
    const handleCLoseDialog  = () => {
        setDialog({...dialog, open: false})
    }
    const getNamefilterCode = (row) =>{
        // console.log(row,certificates);
        let filter = filterArrayEqual(certificates, 'codigo', row.type)
        // console.log(filter);
        return filter.name
    }
    const renderTableMovements = () => {
        if (loading) {
            return <CircularProgress />
        } else {
            if (codespaginate.length > 0) {
                return  <div className = { "container" }>
                        <Grid item xs={12} md={12} lg = {12}>
                            <Table className = {"table"}>
                                <Thead>
                                    <Tr>
                                        <Th>Codigo</Th>
                                        <Th>Nombre</Th>
                                        <Th>Estado</Th>
                                        <Th>Fecha de Caducidad</Th>
                                        <Th>Opciones</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    { 
                                        
                                        codespaginate.map(row => (
                                            <Tr key={`${row.id}`}>
                                                <Td>{'CERT-'+row.type +'-'+row.certificateSequential}</Td>
                                                <Td>{ certificates.length > 0  ? getNamefilterCode(row) : '' }</Td>
                                                <Td>{row.state ? 'Activo': 'Caducado'}</Td>
                                                <Td>{moment(row.expiryDate).format("DD/MM/YYYY HH:mm:ss")}</Td>
                                                <Td>
                                                    {
                                                        (row.state) &&
                                                            <Button variant="contained"
                                                                onClick = {() => handleViewVoucher(row)}
                                                                fullWidth
                                                                style= {{
                                                                    fontSize: '0.6rem',
                                                                    color: '#1a1919',
                                                                    borderLeft: '3px solid #0073D2',
                                                                    backgroundColor: "white",
                                                                    borderRadius: '0px',
                                                                    //fontFamily: 'Ubuntu',
                                                                    fontWeight: 'bold'
                                                                }}>{(isMobile === true) ? "Compartir" : "Descargar"}</Button>
                                                    }
                                                </Td>
                                            </Tr>
                                        ))
                                        
                                    }
                                    
                                </Tbody>
                            </Table>
                            <Pagination 
                                count = { count } 
                                color = "primary" 
                                page = { page }
                                onChange = { onChangePaginationCodes }
                            />
                        </Grid>
                        </div>
            } else {
                return <Alert severity="info">No se han encontrado certificados en el mes seleccionado.</Alert>
            }
        }
    }
    const renderBody = () => {
        return  <div>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={8} lg = {8} sm = {12}>
                            <Title>Certificados Generados</Title>
                        </Grid>
                        <Grid item xs={12} md={4} lg = {4} sm = {12}>
                            
                        </Grid>
                    </Grid>
                    <SelectForm
                        parameters={props.parameters}
                        name = { 'Periodo' }
                        label = { 'Seleccione periodo '}
                        // data = { [{ id: '1', name: 'data'}] }
                        classes = { classes }
                        dateValue = { dateValue }
                        onSelected = { (val) => handleSelectCode(val)}
                        onSubmit={ handleSubmit }
                    ></SelectForm>
                    <br></br>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Grid container justify="center" spacing={3}  alignItems="flex-end">
                                <Grid item md={4} sm={12} xs={12}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                        <KeyboardDatePicker
                                            autoOk
                                            variant="inline"
                                            format="dd/MM/yyyy"
                                            margin="normal"
                                            id="date-start"
                                            label="Fecha de inicio"
                                            value={dateStart}
                                            onChange={handleDateStart}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item md={4} sm={12} xs={12}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                        <KeyboardDatePicker
                                            autoOk
                                            variant="inline"
                                            format="dd/MM/yyyy"
                                            margin="normal"
                                            id="date-end"
                                            label="Fecha de fin"
                                            value={dateEnd}
                                            onChange={handleDateEnd}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item md={2} sm={6} xs={6}>
                                    <Fab color="primary" aria-label="add" onClick = { handleFindRange } >
                                        <Icon>search</Icon>
                                    </Fab>
                                </Grid>
                                <Grid item md={2} sm={6} xs={6}>
                                    <Fab color="primary" aria-label="add" onClick = { () => history.push('/')} >
                                        <Icon>close</Icon>
                                    </Fab>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <br/> <br/>
                    <Grid container spacing={3} justify="center" alignItems="center">
                        {
                            renderTableMovements()
                        }
                    </Grid>
                </div>
    }
    const renderHeader = () => {
        return  <div>
                    <FormControl variant="outlined" style={{maxWidth: '100%'}}>
                        <InputLabel id="demo-simple-select-outlined-label">Seleccione una Cuenta</InputLabel>
                        <Select
                        label="Seleccione una Cuenta"
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        defaultValue={balances[0]}
                        onChange={(e) => handleAccountFind(e.target.value) }
                        >
                            {
                                balances.map(option => {
                                return <MenuItem key={option.PRODUCTBANKID} value={option}>{`${option.PRODUCTBANKID} - ${option.PRODUCTALIAS}`}</MenuItem>
                                })
                            }
                        </Select>
                    </FormControl>
                </div>
    }
    return (
        <div>
            <Dashboard
                title= "Dashboard"
                body = { renderBody() }
                info = { renderHeader()}
                multiple = { true }
                panel = {2}
            />
            <LoadingScreen open={loading} />
            <StandardDialog 
                handleClose = {handleCLoseDialog}
                open = {dialog.open}
                title = {dialog.title}>
                    { dialog.children }
            </StandardDialog> 
        </div>
    );
}

export default connect(null , { getCodes, sendEmailWithVoucher, findTransferCore })(ConsultCertificatesContainer); 
